module.exports = __webpack_public_path__ + "static/media/cq_nuovo_messaggio_ricevuto.ae8189cb.svg";